import React from 'react';
import SafeHtml  from "../../custom-components/SafeHtml/SafeHtml"

interface TextProps {
    text: string;
}

const Text: React.FC<TextProps> = ({ text = "Enter some text here..."}) => {
    return (
        <SafeHtml
             as="span"
             html={text}
             className="builderiotext"
             style={{ margin: "0px", padding: "0px" }}
        />
    );
};

export default Text;

export const textRegistration = {
    name: "Text ",
    inputs: [
        { 
            name: "text",
            type: "richText",
        },
    ],
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/format-text.svg',
    description: 'Add a text component to the page',
}